/**
 * @file MergedVideoTile.js
 * @description Auto-maintained cleanup: comments & minor a11y/robustness. No UI/feature changes.
 */
import React from 'react';
import './MergedVideoTile.css';

const MergedVideoTile = ({ videoUrl, title = "Movie" }) => {
  if (!videoUrl) return null;
  return (
<div className="merged-video-tile">
      <div className="merged-title-bar">
        <h3>{title}</h3>
        <button className="regenerate-button" >⟳</button>
      </div>
      <video src={videoUrl} controls className="merged-scene-video" />
    </div>
  );
};

export default MergedVideoTile;
